import { createContext } from 'react';

const XeroContext = createContext({ services: [] });

export default XeroContext;
